import { z } from 'zod'
import { ServiceStatus } from '~/enums/service-status'
import { listRequestDataSchema } from './list-request-data'

/**
 * 問題答覆 - 查詢多筆 Request Schema
 */
export const getServiceIssueListRequestSchema = listRequestDataSchema.merge(
  z.object({
    /** 技術服務問題序號 */
    siID: z.number().optional(),
    /** 問題關鍵字 */
    q: z.string().optional(),
    /** 產品版本 */
    productVersion: z.string().optional(),
    /** 產品主類目 */
    pmID: z.union([z.number(), z.array(z.number())]).optional(),
    /** 問題分類 */
    serviceClass: z.string().optional(),
    /** 提問人 */
    whoAsk: z.string().optional(),
    /** 答覆人員 */
    reply: z.string().optional(),
    /** 提問時間-起日 */
    createDateS: z.string().optional(),
    /** 提問時間-迄日 */
    createDateE: z.string().optional(),
    /** 是否結案 */
    serviceStatus: z.array(z.nativeEnum(ServiceStatus)).optional()
  })
)

/**
 * 問題答覆 - 查詢多筆 Request
 */
export interface GetServiceIssueListRequest
  extends z.infer<typeof getServiceIssueListRequestSchema> {}
